import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import OpeningLibrary from "./components/OpeningLibrary";
import GoldenLines from "./components/GoldenLines";
import CaseStudy from "./components/CaseStudy";
import Pitfalls from "./components/Pitfalls";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "搭讪开场白真的有用吗？还是看脸？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "看脸是幸存者偏差的错觉。搭讪的核心不是你说得够不够漂亮，而是你有没有让对方舒服地接话。真诚的语气、得体的距离、对现场细节的观察，比任何金句都重要。",
      },
    },
    {
      "@type": "Question",
      name: "第一句话该从哪个场景切入最不容易尬？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "没有绝对安全的场景，但有更不容易尬的切口：永远从双方正在共享的现场出发。咖啡馆聊菜单、健身房请教动作、通勤聊路况、聚会聊别人的话题。",
      },
    },
    {
      "@type": "Question",
      name: "被对方拒绝了，该怎么体面收场？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "拒绝不等于否定你这个人。最体面的收场是快速大方地退一步，干净利落地走开。你越能坦然接受结果，对方反而越会对你留一个好印象。",
      },
    },
  ],
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="relative">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <OpeningLibrary />
        <GoldenLines />
        <CaseStudy />
        <Pitfalls />
        <Faq />
      </main>
      <Footer />

      <button
        onClick={toTop}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-foreground-950 text-background-50 shadow-lg flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-primary-600 ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}